export const translations = {
  'pt-BR': {
    // Products
    myProducts: 'Meus Produtos',
    addProduct: 'Adicionar Produto',
    newProduct: 'Novo Produto',
    productName: 'Nome do Produto',
    productType: 'Tipo',
    targetAudience: 'Público Principal',
    productLogo: 'Logo do Produto',
    ebook: 'E-Book',
    course: 'Curso',
    saas: 'SaaS',
    b2c: 'B2C',
    b2b: 'B2B',
    selectProduct: 'Selecione um produto',
    noProducts: 'Nenhum produto cadastrado ainda',
    allProducts: 'Todos os Produtos',
    product: 'Produto',
    globalGoal: 'Meta Global',
    addProductMethod: 'Como deseja adicionar um produto?',
    manualEntry: 'Entrada Manual',
    manualEntryDesc: 'Preencha os dados do produto manualmente',
    viaIntegration: 'Via Integração',
    viaIntegrationDesc: 'Conecte com seus gateways de pagamento',
    viaUpload: 'Via Upload',
    viaUploadDesc: 'Importe dados de planilhas Excel',
    chooseFile: 'Escolher arquivo',
    uploadImage: 'Fazer upload de imagem',
    manual: 'Manual',
    manualDesc: 'Inserir dados manualmente',
    integration: 'Integração',
    integrationDesc: 'Conectar gateway de pagamento',
    uploadExcel: 'Upload',
    uploadExcelDesc: 'Importar arquivo Excel/CSV',
    newProductManual: 'Novo Produto - Entrada Manual',
    fillProductInfo: 'Preencha as informações do produto',
    back: 'Voltar',
    createProduct: 'Criar Produto',
    editProduct: 'Editar Produto',
    updateProductInfo: 'Atualize as informações do produto',
    updateProduct: 'Atualizar Produto',
    loadingProducts: 'Carregando produtos...',
    awaitingConfig: 'Aguardando configuração da conta...',
    accountBeingConfigured: 'Sua conta está sendo configurada. Por favor, faça logout e login novamente para ativar todas as funcionalidades.',
    
    // Navigation
    dashboard: 'Dashboard',
    dashboardDescription: 'Visão geral e principais métricas',
    customersMenu: 'Clientes',
    customersDescription: 'Gerencie os clientes dos seus produtos',
    transactionsMenu: 'Movimentações',
    transactionsDescription: 'Acompanhe pagamentos e transações',
    metrics: 'Métricas',
    reports: 'Relatórios',
    import: 'Importar',
    integrations: 'Integrações',
    plans: 'Planos',
    integrations_description: 'Conecte seus gateways de pagamento',
    integration_connected: 'Conectado',
    integration_disconnected: 'Desconectado',
    integration_error: 'Erro',
    integration_pending: 'Pendente',
    connect_integration: 'Conectar',
    disconnect_integration: 'Desconectar',
    configure_integration: 'Configurar',
    sync_integration: 'Sincronizar',
    remove_integration: 'Remover',
    webhook_url: 'URL do Webhook',
    last_sync: 'Última sincronização',
    settings: 'Configurações',
    account: 'Conta',
    signOut: 'Sair',
    
    // Dashboard
    monthlyRecurringRevenue: 'Receita Recorrente Mensal',
    annualRecurringRevenue: 'Receita Recorrente Anual',
    totalCustomers: 'Total de Clientes',
    churnRate: 'Taxa de Churn',
    revenueEvolution: 'Evolução da Receita',
    churnEvolution: 'Evolução do Churn',
    
    // Filters
    selectPeriod: 'Selecionar Período',
    last7Days: 'Últimos 7 dias',
    last30Days: 'Últimos 30 dias',
    last90Days: 'Últimos 90 dias',
    last6Months: 'Últimos 6 meses',
    lastYear: 'Último ano',
    customPeriod: 'Período customizado',
    
    // Settings
    settingsTitle: 'Configurações',
    settingsDescription: 'Gerencie seus Produtos, Metas e preferências do sistema',
    goals: 'Metas',
    alerts: 'Alertas',
    preferences: 'Preferências',
    
    // Notifications
    notifications: 'Notificações',
    emailNotifications: 'Notificações por Email',
    emailNotificationsDescription: 'Configure quando deseja receber emails',
    generalNotifications: 'Notificações Gerais',
    generalNotificationsDescription: 'Receber alertas e atualizações importantes',
    weeklyReport: 'Relatório Semanal',
    weeklyReportDescription: 'Resumo semanal das métricas',
    monthlyReport: 'Relatório Mensal',
    monthlyReportDescription: 'Análise completa do mês',
    pushNotifications: 'Notificações Push',
    pushNotificationsDescription: 'Notificações em tempo real no navegador',
    enablePush: 'Habilitar Push',
    enablePushDescription: 'Receber notificações no navegador',
    unreadNotifications: 'Não Lidas',
    readNotifications: 'Lidas',
    allNotifications: 'Todas',
    markAllAsRead: 'Marcar todas como lidas',
    markAsRead: 'Marcar como lida',
    noNotifications: 'Nenhuma notificação',
    noUnreadNotifications: 'Nenhuma notificação não lida',
    noReadNotifications: 'Nenhuma notificação lida',
    noNotificationsFound: 'Nenhuma notificação encontrada',
    searchNotifications: 'Buscar notificações...',
    viewAllNotifications: 'Ver todas',
    manageYourNotifications: 'Gerencie suas notificações do sistema',
    
    // Goals
    businessGoals: 'Metas de Negócio',
    businessGoalsDescription: 'Defina objetivos para seu SaaS',
    newGoal: 'Nova Meta',
    createNewGoal: 'Criar Nova Meta',
    createNewGoalDescription: 'Defina uma meta para acompanhar',
    goalType: 'Tipo de Meta',
    targetValue: 'Valor Alvo',
    period: 'Período',
    year: 'Ano',
    month: 'Mês',
    quarter: 'Trimestre',
    cancel: 'Cancelar',
    createGoal: 'Criar Meta',
    creating: 'Criando...',
    noGoalsDefined: 'Nenhuma meta definida ainda',
    clickNewGoal: 'Clique em "Nova Meta" para começar',
    
    // Goal Types
    mrr: 'MRR (Receita Mensal Recorrente)',
    arr: 'ARR (Receita Anual Recorrente)',
    customers: 'Número de Clientes',
    churn: 'Taxa de Churn (%)',
    
    // Metric Descriptions
    mrrDescription: 'Receita Recorrente Mensal - Receita previsível que sua empresa recebe todos os meses de assinaturas ativas.',
    arrDescription: 'Receita Recorrente Anual - Valor da receita recorrente mensal multiplicado por 12, representando a receita anual de assinaturas.',
    churnDescription: 'Taxa de Churn - Percentual de clientes que cancelaram suas assinaturas no período analisado.',
    totalRevenueDescription: 'Receita Total - Soma de todas as receitas recebidas no período, incluindo assinaturas, upgrades e vendas únicas.',
    cacDescription: 'Custo de Aquisição de Cliente - Investimento médio necessário para conquistar um novo cliente.',
    ltvDescription: 'Lifetime Value - Valor total que um cliente gera para sua empresa durante todo o relacionamento.',
    averageTicketDescription: 'Ticket Médio - Valor médio gasto por cliente em suas compras ou assinaturas.',
    
    // Periods
    daily: 'Diário',
    monthly: 'Mensal',
    quarterly: 'Trimestral',
    semiannual: 'Semestral',
    yearly: 'Anual',
    
    // Goal Validity
    validityPeriod: 'Período de Vigência',
    startDate: 'Data de Início',
    endDate: 'Data de Término',
    selectDate: 'Selecionar data',
    activeGoal: 'Meta Ativa',
    futureGoal: 'Meta Futura',
    expiredGoal: 'Meta Expirada',
    dateConflict: 'Já existe uma meta neste período',
    invalidDateRange: 'Data final deve ser maior que a inicial',
    duration: 'Duração',
    months: 'meses',
    
    // Goal Filters
    filterByProduct: 'Filtrar por Produto',
    showingXGoals: 'Exibindo {x} metas',
    showingXGoalsFor: 'Exibindo {x} metas do produto {product}',
    clearFilter: 'Limpar Filtro',
    noGoalsForProduct: 'Nenhuma meta para este produto',
    tryAnotherProduct: 'Tente selecionar outro produto',
    editGoal: 'Editar Meta',
    editGoalDescription: 'Atualize as informações da meta',
    updateGoal: 'Atualizar Meta',
    updating: 'Atualizando...',
    goalCreatedOn: 'Meta criada em',
    by: 'por',
    lastEditedOn: 'Última edição em',
    
    // Alerts
    automaticAlerts: 'Alertas Automáticos',
    automaticAlertsDescription: 'Receba notificações quando eventos importantes ocorrerem',
    highChurnAlert: 'Alerta de Churn Alto',
    highChurnAlertDescription: 'Notificar quando churn ultrapassar o limite',
    churnThreshold: 'Limite de Churn (%)',
    lowRevenueAlert: 'Alerta de Receita Baixa',
    lowRevenueAlertDescription: 'Notificar quando receita cair significativamente',
    goalAchievedAlert: 'Alerta de Meta Atingida',
    goalAchievedAlertDescription: 'Notificar quando uma meta for alcançada',
    
    // Preferences
    generalPreferences: 'Preferências Gerais',
    generalPreferencesDescription: 'Personalize sua experiência no Dashi',
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Escuro',
    timezone: 'Fuso Horário',
    language: 'Idioma',
    
    // Account
    myAccount: 'Minha Conta',
    accountDescription: 'Gerencie suas informações pessoais e da empresa',
    personalInformation: 'Informações Pessoais',
    fullName: 'Nome Completo',
    email: 'Email',
    phone: 'Telefone',
    companyInformation: 'Informações da Empresa',
    companyName: 'Nome da Empresa',
    domain: 'Domínio',
    save: 'Salvar',
    saving: 'Salvando...',
    
    // Dashboard & Headers
    dashboardTitle: 'Dashboard SaaS',
    dashboardSubtitle: 'Acompanhe suas principais métricas financeiras em tempo real',
    importData: 'Importar Dados',
    exportPDF: 'Exportar PDF',
    generateReport: 'Gerar Relatório',
    vsPreviousPeriod: 'vs período anterior',

    // Period Filters
    last7days: 'Últimos 7 dias',
    currentMonth: 'Mês atual',
    lastQuarter: 'Último trimestre',
    customized: 'Personalizado',

    // Charts
    revenueEvolutionTitle: 'Evolução de Receita',
    revenueEvolutionSubtitle: 'Receita ao longo do período',
    churnRateTitle: 'Taxa de Churn',
    churnRateSubtitle: 'Comparativo com meta de 3%',
    revenue: 'Receita',
    realChurn: 'Churn Real',

    // Info Cards
    connectPaymentGateways: 'Conecte seus gateways de pagamento',
    integrateWithStripe: 'Integre com Stripe, PayPal, Mercado Pago e outros para atualização automática das métricas.',

    // Account Page
    userPhoto: 'Foto do Usuário',
    cnpj: 'CNPJ',
    address: 'Endereço',
    street: 'Rua',
    number: 'Número',
    complement: 'Complemento',
    neighborhood: 'Bairro',
    city: 'Cidade',
    state: 'Estado',
    zipcode: 'CEP',
    edit: 'Editar',
    delete: 'Excluir',
    companyLogo: 'Logo da Empresa',
    accountCreatedOn: 'Conta criada em',
    role: 'Função',
    superAdmin: 'Super Admin',
    admin: 'Administrador',
    employee: 'Funcionário',
    managePersonalInfo: 'Gerencie suas informações pessoais e da empresa',
    companyInfo: 'Informações da Empresa',
    personalInfo: 'Informações Pessoais',
    dashiPlan: 'Plano Dashi',
    companyDetails: 'Dados da sua organização no Dashi',
    squareImageRecommended: 'Recomendado: imagem quadrada (PNG ou JPG)',
    basicData: 'Dados Básicos',
    companyNameRequired: 'Nome da Empresa *',
    contact: 'Contato',

    // Reports
    reportsTitle: 'Relatórios',
    reportsSubtitle: 'Exporte relatórios personalizados em PDF ou Excel',
    monthlyReportTitle: 'Relatório Mensal',
    monthlyReportDesc: 'Todas as métricas do último mês',
    quarterlyReportTitle: 'Relatório Trimestral',
    quarterlyReportDesc: 'Análise dos últimos 3 meses',
    customReportTitle: 'Relatório Personalizado',
    customReportDesc: 'Escolha período e métricas',
    generatePDF: 'Gerar PDF',
    configure: 'Configurar',
    dataExport: 'Exportação de Dados',
    exportAllData: 'Exportar todos os dados',
    downloadAllMetrics: 'Baixe todas as suas métricas em formato Excel',
    exportExcel: 'Exportar Excel',

    // Import
    importTitle: 'Importar Dados',
    importSubtitle: 'Faça upload de planilhas Excel com suas métricas',
    downloadTemplate: 'Baixar Modelo',
    selectFile: 'Selecionar Arquivo',
    uploadFile: 'Fazer Upload',
    uploading: 'Enviando...',
    importHistory: 'Histórico de Importações',
    fileName: 'Nome do Arquivo',
    status: 'Status',
    importDate: 'Data de Importação',
    recordsProcessed: 'Registros Processados',
    processing: 'Processando',
    completed: 'Concluído',
    failed: 'Falhou',
    pendingConflicts: 'Conflitos Pendentes',
    fileUploadSection: 'Upload de Arquivo',
    sendYourSpreadsheet: 'Envie sua planilha de dados',
    selectFileLabel: 'Selecione o arquivo',
    acceptedFormats: 'Formatos aceitos: XLSX, XLS (até 10MB)',
    fileSelected: 'Arquivo selecionado',
    templateSpreadsheet: 'Modelo de Planilha',
    useOurTemplate: 'Use nosso template padrão',
    templateIncludes: 'O template inclui:',
    allMetricFields: '• Campos para todas as métricas (MRR, Churn, CAC, LTV)',
    customerData: '• Dados do cliente (nome, email, documento)',
    predefinedFormat: '• Formatação pré-definida',
    fillingExamples: '• Exemplos de preenchimento',
    howToImport: 'Como importar seus dados',
    importStep1: 'Baixe o template de planilha e preencha com seus dados',
    importStep2: 'nome_cliente é obrigatório. Email e documento são opcionais mas ajudam a evitar duplicatas',
    importStep3: 'Se nome_produto for informado, o produto deve estar cadastrado no sistema',
    importStep4: 'Faça o upload do arquivo e aguarde o processamento',
    importStep5: 'Se houver conflitos (clientes com mesmo email mas nome diferente), você será notificado para resolver',

    // Integrations
    integrationsTitle: 'Integrações',
    integrationsSubtitle: 'Conecte seus gateways de pagamento para sincronização automática',
    internationalPaymentGateway: 'Gateway de pagamentos internacional',
    secureOnlinePayments: 'Pagamentos online seguros',
    latinAmericaPayments: 'Solução de pagamentos para América Latina',
    brazilianPaymentGateway: 'Gateway de pagamentos brasileiro',
    infoproductsPlatform: 'Plataforma de infoprodutos',
    checkoutManagement: 'Checkout e gestão de infoprodutos',
    subscriptionManagement: 'Gestão de recorrência e cobranças',
    financialManagement: 'Gestão financeira e pagamentos',
    digitalSalesPlatform: 'Plataforma de vendas digitais',

    // Metrics Page
    metricsAnalysis: 'Análise de Métricas',
    detailedPerformance: 'Análise detalhada do desempenho do seu negócio',
    mrrGrowth: 'Crescimento MRR',
    churnReduction: 'Redução Churn',
    vsPreviousMonth: 'vs mês anterior',
    detailedAnalysis: 'Análise Detalhada',
    pageInDevelopment: 'Página em desenvolvimento - Em breve você terá acesso a análises detalhadas com gráficos comparativos e insights sobre suas métricas.',

    // Common
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    target: 'Meta',
    selectYear: 'Selecione o Ano',
    selectMonth: 'Selecione o Mês',
    currency: 'Moeda',
  },
  
  'en-US': {
    // Products
    myProducts: 'My Products',
    addProduct: 'Add Product',
    newProduct: 'New Product',
    productName: 'Product Name',
    productType: 'Type',
    targetAudience: 'Target Audience',
    productLogo: 'Product Logo',
    ebook: 'E-Book',
    course: 'Course',
    saas: 'SaaS',
    b2c: 'B2C',
    b2b: 'B2B',
    selectProduct: 'Select a product',
    noProducts: 'No products registered yet',
    allProducts: 'All Products',
    product: 'Product',
    globalGoal: 'Global Goal',
    addProductMethod: 'How would you like to add a product?',
    manualEntry: 'Manual Entry',
    manualEntryDesc: 'Fill in product data manually',
    viaIntegration: 'Via Integration',
    viaIntegrationDesc: 'Connect with your payment gateways',
    viaUpload: 'Via Upload',
    viaUploadDesc: 'Import data from Excel spreadsheets',
    chooseFile: 'Choose file',
    uploadImage: 'Upload image',
    manual: 'Manual',
    manualDesc: 'Enter data manually',
    integration: 'Integration',
    integrationDesc: 'Connect payment gateway',
    uploadExcel: 'Upload',
    uploadExcelDesc: 'Import Excel/CSV file',
    newProductManual: 'New Product - Manual Entry',
    fillProductInfo: 'Fill in product information',
    back: 'Back',
    createProduct: 'Create Product',
    editProduct: 'Edit Product',
    updateProductInfo: 'Update product information',
    updateProduct: 'Update Product',
    loadingProducts: 'Loading products...',
    awaitingConfig: 'Awaiting account configuration...',
    accountBeingConfigured: 'Your account is being configured. Please log out and log in again to activate all features.',

    // Navigation
    dashboard: 'Dashboard',
    dashboardDescription: 'Overview and key metrics',
    customersMenu: 'Customers',
    customersDescription: 'Manage your product customers',
    transactionsMenu: 'Transactions',
    transactionsDescription: 'Track payments and transactions',
    metrics: 'Metrics',
    reports: 'Reports',
    import: 'Import',
    integrations: 'Integrations',
    plans: 'Plans',
    integrations_description: 'Connect your payment gateways',
    integration_connected: 'Connected',
    integration_disconnected: 'Disconnected',
    integration_error: 'Error',
    integration_pending: 'Pending',
    connect_integration: 'Connect',
    disconnect_integration: 'Disconnect',
    configure_integration: 'Configure',
    sync_integration: 'Sync',
    remove_integration: 'Remove',
    webhook_url: 'Webhook URL',
    last_sync: 'Last sync',
    settings: 'Settings',
    account: 'Account',
    signOut: 'Sign Out',
    
    // Dashboard
    monthlyRecurringRevenue: 'Monthly Recurring Revenue',
    annualRecurringRevenue: 'Annual Recurring Revenue',
    totalCustomers: 'Total Customers',
    churnRate: 'Churn Rate',
    revenueEvolution: 'Revenue Evolution',
    churnEvolution: 'Churn Evolution',
    
    // Filters
    selectPeriod: 'Select Period',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    last6Months: 'Last 6 months',
    lastYear: 'Last year',
    customPeriod: 'Custom period',
    
    // Settings
    settingsTitle: 'Settings',
    settingsDescription: 'Manage your Products, Goals and system preferences',
    notifications: 'Notifications',
    goals: 'Goals',
    alerts: 'Alerts',
    preferences: 'Preferences',
    
    // Notifications
    emailNotifications: 'Email Notifications',
    emailNotificationsDescription: 'Configure when you want to receive emails',
    generalNotifications: 'General Notifications',
    generalNotificationsDescription: 'Receive important alerts and updates',
    weeklyReport: 'Weekly Report',
    weeklyReportDescription: 'Weekly metrics summary',
    monthlyReport: 'Monthly Report',
    monthlyReportDescription: 'Complete monthly analysis',
    pushNotifications: 'Push Notifications',
    pushNotificationsDescription: 'Real-time browser notifications',
    enablePush: 'Enable Push',
    enablePushDescription: 'Receive browser notifications',
    
    // Goals
    businessGoals: 'Business Goals',
    businessGoalsDescription: 'Set objectives for your SaaS',
    newGoal: 'New Goal',
    createNewGoal: 'Create New Goal',
    createNewGoalDescription: 'Define a goal to track',
    goalType: 'Goal Type',
    targetValue: 'Target Value',
    period: 'Period',
    year: 'Year',
    month: 'Month',
    quarter: 'Quarter',
    cancel: 'Cancel',
    createGoal: 'Create Goal',
    creating: 'Creating...',
    noGoalsDefined: 'No goals defined yet',
    clickNewGoal: 'Click "New Goal" to get started',
    
    // Goal Types
    mrr: 'MRR (Monthly Recurring Revenue)',
    arr: 'ARR (Annual Recurring Revenue)',
    customers: 'Number of Customers',
    churn: 'Churn Rate (%)',
    
    // Metric Descriptions
    mrrDescription: 'Monthly Recurring Revenue - Predictable revenue your business receives every month from active subscriptions.',
    arrDescription: 'Annual Recurring Revenue - Monthly recurring revenue multiplied by 12, representing annual subscription revenue.',
    churnDescription: 'Churn Rate - Percentage of customers who cancelled their subscriptions during the analyzed period.',
    totalRevenueDescription: 'Total Revenue - Sum of all revenue received in the period, including subscriptions, upgrades and one-time sales.',
    cacDescription: 'Customer Acquisition Cost - Average investment needed to acquire a new customer.',
    ltvDescription: 'Lifetime Value - Total value a customer generates for your business throughout the entire relationship.',
    averageTicketDescription: 'Average Ticket - Average amount spent by customer on their purchases or subscriptions.',
    
    // Periods
    daily: 'Daily',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    semiannual: 'Semiannual',
    yearly: 'Yearly',
    
    // Goal Validity
    validityPeriod: 'Validity Period',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectDate: 'Select date',
    activeGoal: 'Active Goal',
    futureGoal: 'Future Goal',
    expiredGoal: 'Expired Goal',
    dateConflict: 'A goal already exists in this period',
    invalidDateRange: 'End date must be greater than start date',
    duration: 'Duration',
    months: 'months',
    
    // Goal Filters
    filterByProduct: 'Filter by Product',
    showingXGoals: 'Showing {x} goals',
    showingXGoalsFor: 'Showing {x} goals for {product}',
    clearFilter: 'Clear Filter',
    noGoalsForProduct: 'No goals for this product',
    tryAnotherProduct: 'Try selecting another product',
    editGoal: 'Edit Goal',
    editGoalDescription: 'Update goal information',
    updateGoal: 'Update Goal',
    updating: 'Updating...',
    goalCreatedOn: 'Goal created on',
    by: 'by',
    lastEditedOn: 'Last edited on',
    
    // Alerts
    automaticAlerts: 'Automatic Alerts',
    automaticAlertsDescription: 'Receive notifications when important events occur',
    highChurnAlert: 'High Churn Alert',
    highChurnAlertDescription: 'Notify when churn exceeds threshold',
    churnThreshold: 'Churn Threshold (%)',
    lowRevenueAlert: 'Low Revenue Alert',
    lowRevenueAlertDescription: 'Notify when revenue drops significantly',
    goalAchievedAlert: 'Goal Achieved Alert',
    goalAchievedAlertDescription: 'Notify when a goal is reached',
    
    // Preferences
    generalPreferences: 'General Preferences',
    generalPreferencesDescription: 'Customize your Dashi experience',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    timezone: 'Timezone',
    language: 'Language',
    
    // Account
    myAccount: 'My Account',
    accountDescription: 'Manage your personal and company information',
    personalInformation: 'Personal Information',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    companyInformation: 'Company Information',
    companyName: 'Company Name',
    domain: 'Domain',
    save: 'Save',
    saving: 'Saving...',
    
    // Dashboard & Headers
    dashboardTitle: 'SaaS Dashboard',
    dashboardSubtitle: 'Track your key financial metrics in real time',
    importData: 'Import Data',
    exportPDF: 'Export PDF',
    generateReport: 'Generate Report',
    vsPreviousPeriod: 'vs previous period',

    // Period Filters
    last7days: 'Last 7 days',
    currentMonth: 'Current month',
    lastQuarter: 'Last quarter',
    customized: 'Custom',

    // Charts
    revenueEvolutionTitle: 'Revenue Evolution',
    revenueEvolutionSubtitle: 'Revenue over period',
    churnRateTitle: 'Churn Rate',
    churnRateSubtitle: 'Comparison with 3% target',
    revenue: 'Revenue',
    realChurn: 'Actual Churn',

    // Info Cards
    connectPaymentGateways: 'Connect your payment gateways',
    integrateWithStripe: 'Integrate with Stripe, PayPal, Mercado Pago and others for automatic metrics updates.',

    // Account Page
    userPhoto: 'User Photo',
    cnpj: 'Tax ID',
    address: 'Address',
    street: 'Street',
    number: 'Number',
    complement: 'Complement',
    neighborhood: 'Neighborhood',
    city: 'City',
    state: 'State',
    zipcode: 'ZIP Code',
    edit: 'Edit',
    delete: 'Delete',
    companyLogo: 'Company Logo',
    accountCreatedOn: 'Account created on',
    role: 'Role',
    superAdmin: 'Super Admin',
    admin: 'Administrator',
    employee: 'Employee',
    managePersonalInfo: 'Manage your personal and company information',
    companyInfo: 'Company Information',
    personalInfo: 'Personal Information',
    dashiPlan: 'Dashi Plan',
    companyDetails: 'Your organization data in Dashi',
    squareImageRecommended: 'Recommended: square image (PNG or JPG)',
    basicData: 'Basic Data',
    companyNameRequired: 'Company Name *',
    contact: 'Contact',

    // Reports
    reportsTitle: 'Reports',
    reportsSubtitle: 'Export custom reports in PDF or Excel',
    monthlyReportTitle: 'Monthly Report',
    monthlyReportDesc: 'All metrics from last month',
    quarterlyReportTitle: 'Quarterly Report',
    quarterlyReportDesc: 'Analysis of last 3 months',
    customReportTitle: 'Custom Report',
    customReportDesc: 'Choose period and metrics',
    generatePDF: 'Generate PDF',
    configure: 'Configure',
    dataExport: 'Data Export',
    exportAllData: 'Export all data',
    downloadAllMetrics: 'Download all your metrics in Excel format',
    exportExcel: 'Export Excel',

    // Import
    importTitle: 'Import Data',
    importSubtitle: 'Upload Excel spreadsheets with your metrics',
    downloadTemplate: 'Download Template',
    selectFile: 'Select File',
    uploadFile: 'Upload File',
    uploading: 'Uploading...',
    importHistory: 'Import History',
    fileName: 'File Name',
    status: 'Status',
    importDate: 'Import Date',
    recordsProcessed: 'Records Processed',
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
    pendingConflicts: 'Pending Conflicts',
    fileUploadSection: 'File Upload',
    sendYourSpreadsheet: 'Upload your data spreadsheet',
    selectFileLabel: 'Select file',
    acceptedFormats: 'Accepted formats: XLSX, XLS (up to 10MB)',
    fileSelected: 'File selected',
    templateSpreadsheet: 'Template Spreadsheet',
    useOurTemplate: 'Use our standard template',
    templateIncludes: 'The template includes:',
    allMetricFields: '• Fields for all metrics (MRR, Churn, CAC, LTV)',
    customerData: '• Customer data (name, email, tax ID)',
    predefinedFormat: '• Pre-defined formatting',
    fillingExamples: '• Filling examples',
    howToImport: 'How to import your data',
    importStep1: 'Download the spreadsheet template and fill it with your data',
    importStep2: 'customer_name is required. Email and tax ID are optional but help avoid duplicates',
    importStep3: 'If product_name is provided, the product must be registered in the system',
    importStep4: 'Upload the file and wait for processing',
    importStep5: 'If there are conflicts (customers with same email but different name), you will be notified to resolve',

    // Integrations
    integrationsTitle: 'Integrations',
    integrationsSubtitle: 'Connect your payment gateways for automatic synchronization',
    internationalPaymentGateway: 'International payment gateway',
    secureOnlinePayments: 'Secure online payments',
    latinAmericaPayments: 'Payment solution for Latin America',
    brazilianPaymentGateway: 'Brazilian payment gateway',
    infoproductsPlatform: 'Digital products platform',
    checkoutManagement: 'Checkout and digital products management',
    subscriptionManagement: 'Subscription and billing management',
    financialManagement: 'Financial management and payments',
    digitalSalesPlatform: 'Digital sales platform',

    // Metrics Page
    metricsAnalysis: 'Metrics Analysis',
    detailedPerformance: 'Detailed analysis of your business performance',
    mrrGrowth: 'MRR Growth',
    churnReduction: 'Churn Reduction',
    vsPreviousMonth: 'vs previous month',
    detailedAnalysis: 'Detailed Analysis',
    pageInDevelopment: 'Page under development - Soon you will have access to detailed analyses with comparative charts and insights about your metrics.',
    
    // Common
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    target: 'Target',
    selectYear: 'Select Year',
    selectMonth: 'Select Month',
    currency: 'Currency',
  },
  
  'es-ES': {
    // Products
    myProducts: 'Mis Productos',
    addProduct: 'Agregar Producto',
    newProduct: 'Nuevo Producto',
    productName: 'Nombre del Producto',
    productType: 'Tipo',
    targetAudience: 'Público Objetivo',
    productLogo: 'Logo del Producto',
    ebook: 'E-Book',
    course: 'Curso',
    saas: 'SaaS',
    b2c: 'B2C',
    b2b: 'B2B',
    selectProduct: 'Seleccione un producto',
    noProducts: 'Ningún producto registrado aún',
    allProducts: 'Todos los Productos',
    product: 'Producto',
    globalGoal: 'Objetivo Global',
    addProductMethod: '¿Cómo desea agregar un producto?',
    manualEntry: 'Entrada Manual',
    manualEntryDesc: 'Complete los datos del producto manualmente',
    viaIntegration: 'Vía Integración',
    viaIntegrationDesc: 'Conecte con sus pasarelas de pago',
    viaUpload: 'Vía Carga',
    viaUploadDesc: 'Importe datos de hojas de cálculo Excel',
    chooseFile: 'Elegir archivo',
    uploadImage: 'Subir imagen',
    manual: 'Manual',
    manualDesc: 'Insertar datos manualmente',
    integration: 'Integración',
    integrationDesc: 'Conectar pasarela de pago',
    uploadExcel: 'Cargar',
    uploadExcelDesc: 'Importar archivo Excel/CSV',
    newProductManual: 'Nuevo Producto - Entrada Manual',
    fillProductInfo: 'Complete la información del producto',
    back: 'Volver',
    createProduct: 'Crear Producto',
    editProduct: 'Editar Producto',
    updateProductInfo: 'Actualice la información del producto',
    updateProduct: 'Actualizar Producto',
    loadingProducts: 'Cargando productos...',
    awaitingConfig: 'Esperando configuración de la cuenta...',
    accountBeingConfigured: 'Su cuenta está siendo configurada. Por favor, cierre sesión e inicie sesión nuevamente para activar todas las funciones.',

    // Navigation
    dashboard: 'Panel',
    dashboardDescription: 'Resumen y métricas clave',
    customersMenu: 'Clientes',
    customersDescription: 'Gestione los clientes de sus productos',
    transactionsMenu: 'Movimientos',
    transactionsDescription: 'Seguimiento de pagos y transacciones',
    metrics: 'Métricas',
    reports: 'Informes',
    import: 'Importar',
    integrations: 'Integraciones',
    integrations_description: 'Conecte sus pasarelas de pago',
    integration_connected: 'Conectado',
    integration_disconnected: 'Desconectado',
    integration_error: 'Error',
    integration_pending: 'Pendiente',
    connect_integration: 'Conectar',
    disconnect_integration: 'Desconectar',
    configure_integration: 'Configurar',
    sync_integration: 'Sincronizar',
    remove_integration: 'Eliminar',
    webhook_url: 'URL del Webhook',
    last_sync: 'Última sincronización',
    settings: 'Configuración',
    account: 'Cuenta',
    signOut: 'Cerrar Sesión',
    
    // Dashboard
    monthlyRecurringRevenue: 'Ingresos Recurrentes Mensuales',
    annualRecurringRevenue: 'Ingresos Recurrentes Anuales',
    totalCustomers: 'Total de Clientes',
    churnRate: 'Tasa de Abandono',
    revenueEvolution: 'Evolución de Ingresos',
    churnEvolution: 'Evolución del Abandono',
    
    // Filters
    selectPeriod: 'Seleccionar Período',
    last7Days: 'Últimos 7 días',
    last30Days: 'Últimos 30 días',
    last90Days: 'Últimos 90 días',
    last6Months: 'Últimos 6 meses',
    lastYear: 'Último año',
    customPeriod: 'Período personalizado',
    
    // Settings
    settingsTitle: 'Configuración',
    settingsDescription: 'Gestionar sus Productos, Objetivos y preferencias del sistema',
    notifications: 'Notificaciones',
    goals: 'Objetivos',
    alerts: 'Alertas',
    preferences: 'Preferencias',
    
    // Notifications
    emailNotifications: 'Notificaciones por Email',
    emailNotificationsDescription: 'Configurar cuándo desea recibir emails',
    generalNotifications: 'Notificaciones Generales',
    generalNotificationsDescription: 'Recibir alertas y actualizaciones importantes',
    weeklyReport: 'Informe Semanal',
    weeklyReportDescription: 'Resumen semanal de métricas',
    monthlyReport: 'Informe Mensual',
    monthlyReportDescription: 'Análisis completo del mes',
    pushNotifications: 'Notificaciones Push',
    pushNotificationsDescription: 'Notificaciones en tiempo real en el navegador',
    enablePush: 'Habilitar Push',
    enablePushDescription: 'Recibir notificaciones en el navegador',
    
    // Goals
    businessGoals: 'Objetivos de Negocio',
    businessGoalsDescription: 'Definir objetivos para su SaaS',
    newGoal: 'Nuevo Objetivo',
    createNewGoal: 'Crear Nuevo Objetivo',
    createNewGoalDescription: 'Definir un objetivo para seguir',
    goalType: 'Tipo de Objetivo',
    targetValue: 'Valor Objetivo',
    period: 'Período',
    year: 'Año',
    month: 'Mes',
    quarter: 'Trimestre',
    cancel: 'Cancelar',
    createGoal: 'Crear Objetivo',
    creating: 'Creando...',
    noGoalsDefined: 'Ningún objetivo definido aún',
    clickNewGoal: 'Haga clic en "Nuevo Objetivo" para comenzar',
    
    // Goal Types
    mrr: 'MRR (Ingresos Mensuales Recurrentes)',
    arr: 'ARR (Ingresos Anuales Recurrentes)',
    customers: 'Número de Clientes',
    churn: 'Tasa de Abandono (%)',
    
    // Metric Descriptions
    mrrDescription: 'Ingresos Recurrentes Mensuales - Ingresos predecibles que su empresa recibe cada mes de suscripciones activas.',
    arrDescription: 'Ingresos Recurrentes Anuales - Valor de los ingresos recurrentes mensuales multiplicado por 12, representando los ingresos anuales de suscripciones.',
    churnDescription: 'Tasa de Abandono - Porcentaje de clientes que cancelaron sus suscripciones en el período analizado.',
    totalRevenueDescription: 'Ingresos Totales - Suma de todos los ingresos recibidos en el período, incluyendo suscripciones, mejoras y ventas únicas.',
    cacDescription: 'Costo de Adquisición de Cliente - Inversión promedio necesaria para adquirir un nuevo cliente.',
    ltvDescription: 'Valor del Tiempo de Vida - Valor total que un cliente genera para su empresa durante toda la relación.',
    averageTicketDescription: 'Ticket Promedio - Valor promedio gastado por cliente en sus compras o suscripciones.',
    
    // Periods
    daily: 'Diario',
    monthly: 'Mensual',
    quarterly: 'Trimestral',
    semiannual: 'Semestral',
    yearly: 'Anual',
    
    // Goal Validity
    validityPeriod: 'Período de Vigencia',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Término',
    selectDate: 'Seleccionar fecha',
    activeGoal: 'Objetivo Activo',
    futureGoal: 'Objetivo Futuro',
    expiredGoal: 'Objetivo Expirado',
    dateConflict: 'Ya existe un objetivo en este período',
    invalidDateRange: 'La fecha final debe ser mayor que la inicial',
    duration: 'Duración',
    months: 'meses',
    
    // Goal Filters
    filterByProduct: 'Filtrar por Producto',
    showingXGoals: 'Mostrando {x} objetivos',
    showingXGoalsFor: 'Mostrando {x} objetivos del producto {product}',
    clearFilter: 'Limpiar Filtro',
    noGoalsForProduct: 'No hay objetivos para este producto',
    tryAnotherProduct: 'Intente seleccionar otro producto',
    editGoal: 'Editar Objetivo',
    editGoalDescription: 'Actualizar información del objetivo',
    updateGoal: 'Actualizar Objetivo',
    updating: 'Actualizando...',
    goalCreatedOn: 'Objetivo creado el',
    by: 'por',
    lastEditedOn: 'Última edición el',
    
    // Alerts
    automaticAlerts: 'Alertas Automáticas',
    automaticAlertsDescription: 'Recibir notificaciones cuando ocurran eventos importantes',
    highChurnAlert: 'Alerta de Abandono Alto',
    highChurnAlertDescription: 'Notificar cuando el abandono supere el límite',
    churnThreshold: 'Límite de Abandono (%)',
    lowRevenueAlert: 'Alerta de Ingresos Bajos',
    lowRevenueAlertDescription: 'Notificar cuando los ingresos caigan significativamente',
    goalAchievedAlert: 'Alerta de Objetivo Alcanzado',
    goalAchievedAlertDescription: 'Notificar cuando se alcance un objetivo',
    
    // Preferences
    generalPreferences: 'Preferencias Generales',
    generalPreferencesDescription: 'Personalizar su experiencia en Dashi',
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    timezone: 'Zona Horaria',
    language: 'Idioma',
    
    // Account
    myAccount: 'Mi Cuenta',
    accountDescription: 'Gestionar su información personal y de empresa',
    personalInformation: 'Información Personal',
    fullName: 'Nombre Completo',
    email: 'Email',
    phone: 'Teléfono',
    companyInformation: 'Información de la Empresa',
    companyName: 'Nombre de la Empresa',
    domain: 'Dominio',
    save: 'Guardar',
    saving: 'Guardando...',
    
    // Dashboard & Headers
    dashboardTitle: 'Panel SaaS',
    dashboardSubtitle: 'Siga sus principales métricas financieras en tiempo real',
    importData: 'Importar Datos',
    exportPDF: 'Exportar PDF',
    generateReport: 'Generar Informe',
    vsPreviousPeriod: 'vs período anterior',

    // Period Filters
    last7days: 'Últimos 7 días',
    currentMonth: 'Mes actual',
    lastQuarter: 'Último trimestre',
    customized: 'Personalizado',

    // Charts
    revenueEvolutionTitle: 'Evolución de Ingresos',
    revenueEvolutionSubtitle: 'Ingresos a lo largo del período',
    churnRateTitle: 'Tasa de Abandono',
    churnRateSubtitle: 'Comparación con objetivo del 3%',
    revenue: 'Ingresos',
    realChurn: 'Abandono Real',

    // Info Cards
    connectPaymentGateways: 'Conecte sus pasarelas de pago',
    integrateWithStripe: 'Integre con Stripe, PayPal, Mercado Pago y otros para actualización automática de métricas.',

    // Account Page
    userPhoto: 'Foto de Usuario',
    cnpj: 'CUIT',
    address: 'Dirección',
    street: 'Calle',
    number: 'Número',
    complement: 'Complemento',
    neighborhood: 'Barrio',
    city: 'Ciudad',
    state: 'Estado',
    zipcode: 'Código Postal',
    edit: 'Editar',
    delete: 'Eliminar',
    companyLogo: 'Logo de la Empresa',
    accountCreatedOn: 'Cuenta creada el',
    role: 'Función',
    superAdmin: 'Super Admin',
    admin: 'Administrador',
    employee: 'Empleado',
    managePersonalInfo: 'Gestione su información personal y de empresa',
    companyInfo: 'Información de la Empresa',
    personalInfo: 'Información Personal',
    dashiPlan: 'Plan Dashi',
    companyDetails: 'Datos de su organización en Dashi',
    squareImageRecommended: 'Recomendado: imagen cuadrada (PNG o JPG)',
    basicData: 'Datos Básicos',
    companyNameRequired: 'Nombre de la Empresa *',
    contact: 'Contacto',

    // Reports
    reportsTitle: 'Informes',
    reportsSubtitle: 'Exporte informes personalizados en PDF o Excel',
    monthlyReportTitle: 'Informe Mensual',
    monthlyReportDesc: 'Todas las métricas del último mes',
    quarterlyReportTitle: 'Informe Trimestral',
    quarterlyReportDesc: 'Análisis de los últimos 3 meses',
    customReportTitle: 'Informe Personalizado',
    customReportDesc: 'Elija período y métricas',
    generatePDF: 'Generar PDF',
    configure: 'Configurar',
    dataExport: 'Exportación de Datos',
    exportAllData: 'Exportar todos los datos',
    downloadAllMetrics: 'Descargue todas sus métricas en formato Excel',
    exportExcel: 'Exportar Excel',

    // Import
    importTitle: 'Importar Datos',
    importSubtitle: 'Cargue hojas de cálculo Excel con sus métricas',
    downloadTemplate: 'Descargar Modelo',
    selectFile: 'Seleccionar Archivo',
    uploadFile: 'Cargar Archivo',
    uploading: 'Cargando...',
    importHistory: 'Historial de Importaciones',
    fileName: 'Nombre del Archivo',
    status: 'Estado',
    importDate: 'Fecha de Importación',
    recordsProcessed: 'Registros Procesados',
    processing: 'Procesando',
    completed: 'Completado',
    failed: 'Falló',
    pendingConflicts: 'Conflictos Pendientes',
    fileUploadSection: 'Carga de Archivo',
    sendYourSpreadsheet: 'Envíe su hoja de cálculo de datos',
    selectFileLabel: 'Seleccione el archivo',
    acceptedFormats: 'Formatos aceptados: XLSX, XLS (hasta 10MB)',
    fileSelected: 'Archivo seleccionado',
    templateSpreadsheet: 'Modelo de Hoja de Cálculo',
    useOurTemplate: 'Use nuestra plantilla estándar',
    templateIncludes: 'La plantilla incluye:',
    allMetricFields: '• Campos para todas las métricas (MRR, Churn, CAC, LTV)',
    customerData: '• Datos del cliente (nombre, email, documento)',
    predefinedFormat: '• Formato predefinido',
    fillingExamples: '• Ejemplos de llenado',
    howToImport: 'Cómo importar sus datos',
    importStep1: 'Descargue la plantilla de hoja de cálculo y complétela con sus datos',
    importStep2: 'nombre_cliente es obligatorio. Email y documento son opcionales pero ayudan a evitar duplicados',
    importStep3: 'Si nombre_producto es informado, el producto debe estar registrado en el sistema',
    importStep4: 'Cargue el archivo y espere el procesamiento',
    importStep5: 'Si hay conflictos (clientes con mismo email pero nombre diferente), será notificado para resolver',

    // Integrations
    integrationsTitle: 'Integraciones',
    integrationsSubtitle: 'Conecte sus pasarelas de pago para sincronización automática',
    internationalPaymentGateway: 'Pasarela de pagos internacional',
    secureOnlinePayments: 'Pagos en línea seguros',
    latinAmericaPayments: 'Solución de pagos para América Latina',
    brazilianPaymentGateway: 'Pasarela de pagos brasileña',
    infoproductsPlatform: 'Plataforma de infoproductos',
    checkoutManagement: 'Checkout y gestión de infoproductos',
    subscriptionManagement: 'Gestión de recurrencia y cobros',
    financialManagement: 'Gestión financiera y pagos',
    digitalSalesPlatform: 'Plataforma de ventas digitales',

    // Metrics Page
    metricsAnalysis: 'Análisis de Métricas',
    detailedPerformance: 'Análisis detallado del desempeño de su negocio',
    mrrGrowth: 'Crecimiento MRR',
    churnReduction: 'Reducción de Abandono',
    vsPreviousMonth: 'vs mes anterior',
    detailedAnalysis: 'Análisis Detallado',
    pageInDevelopment: 'Página en desarrollo - Pronto tendrá acceso a análisis detallados con gráficos comparativos e insights sobre sus métricas.',
    
    // Common
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    target: 'Objetivo',
    selectYear: 'Seleccionar Año',
    selectMonth: 'Seleccionar Mes',
    currency: 'Moneda',
  },
};

export type TranslationKey = keyof typeof translations['pt-BR'];
export type Language = keyof typeof translations;
